import { S } from "../../app/store.js";
import { ACC } from "../../domain/reference.js";
import { sitePayroll } from "../../domain/payroll.js";
import { projectSite, siteById } from "../sites/model.js";

function projectReportRows(from, to) {
  const rows = [
    ...S.projects.map((p) => ({
      code: p.code,
      label: p.code,
      location: p.site,
    })),
    { code: "", label: "Head office / unassigned", location: "Company costs" },
  ].map((r) => ({
    ...r,
    revenue: 0,
    payroll: 0,
    expenses: 0,
    invoiced: 0,
    outstanding: 0,
    netPay: 0,
    employees: new Set(),
  }));
  const row = (code) =>
      rows.find((r) => r.code === (code || "")) || rows.at(-1),
    within = (d) => d >= from && d <= to;
  const payrollAccounts = ["5100", "5010", "5050", "5055", "5060", "5070"];
  for (const j of S.je.filter((j) => j.status === "POSTED" && within(j.date))) {
    const run = S.runs.find((r) => r.id === j.src),
      r = row(j.project || S.invoices.find((i) => i.no === j.src)?.project);
    if (run && j.lines.some((l) => ACC[l.a]?.type === "X")) {
      (run.siteAllocations || sitePayroll(run)).forEach((l) => {
        const x = row(l.project);
        x.payroll += l.gross + l.allow + l.er + (l.accrual13 || 0);
      });
      continue;
    }
    for (const l of j.lines) {
      if (ACC[l.a]?.type === "R") {
        if (!j.project && ["JV-0002", "JV-0003"].includes(j.id)) {
          const total = S.projects.reduce((a, p) => a + p.recog, 0);
          let used = 0;
          S.projects.forEach((p, i) => {
            const n =
              i === S.projects.length - 1
                ? l.c - l.d - used
                : Math.round(((l.c - l.d) * p.recog) / total);
            row(p.code).revenue += n;
            used += n;
          });
        } else r.revenue += l.c - l.d;
      }
      if (ACC[l.a]?.type === "X") {
        if (payrollAccounts.includes(l.a)) r.payroll += l.d - l.c;
        else r.expenses += l.d - l.c;
      }
    }
  }
  for (const run of S.runs.filter((r) => r.status !== "DRAFT" && within(r.pay)))
    for (const l of sitePayroll(run)) {
      const r = row(l.project);
      r.netPay += l.net;
      r.employees.add(l.emp);
    }
  for (const i of S.invoices) {
    const r = row(i.project);
    if (within(i.date)) r.invoiced += i.gross;
    if (i.date <= to && (!i.paidOn || i.paidOn > to)) r.outstanding += i.due;
  }
  return rows.map((r) => ({
    ...r,
    totalExpenses: r.payroll + r.expenses,
    profit: r.revenue - r.payroll - r.expenses,
  }));
}

function reportRows(from, to, project = "ALL") {
  const groups = new Map();
  if (project === "ALL")
    for (const site of S.sites)
      groups.set(site.id, {
        code: site.id,
        label: site.code,
        location: site.name,
        employees: new Set(),
        revenue: 0,
        payroll: 0,
        expenses: 0,
        totalExpenses: 0,
        profit: 0,
        invoiced: 0,
        outstanding: 0,
        netPay: 0,
      });
  projectReportRows(from, to)
    .filter((r) => project === "ALL" || r.code === project)
    .forEach((r) => {
      const code = projectSite(r.code),
        site = siteById(code);
      if (!groups.has(code))
        groups.set(code, {
          code,
          label: site?.code || "Head office / unassigned",
          location: site?.name || "Company costs",
          employees: new Set(),
          revenue: 0,
          payroll: 0,
          expenses: 0,
          totalExpenses: 0,
          profit: 0,
          invoiced: 0,
          outstanding: 0,
          netPay: 0,
        });
      const x = groups.get(code);
      for (const k of [
        "revenue",
        "payroll",
        "expenses",
        "totalExpenses",
        "profit",
        "invoiced",
        "outstanding",
        "netPay",
      ])
        x[k] += r[k];
      r.employees.forEach((e) => x.employees.add(e));
    });
  return [...groups.values()];
}

export { projectReportRows, reportRows };
